import { ApiService } from "@/services/api/ApiService";

/** A link or picture found inside one of a genie's knowledge documents. */
export interface KnowledgeLink {
  url: string;
  kind: "link" | "image";
  label: string;
  description: string | null;
  documentId: string;
  documentName: string;
}

export interface KnowledgeLinksResult {
  links: KnowledgeLink[];
  documents: {
    total: number;
    scanned: number;
    /** Documents never scanned, or changed since their last scan. */
    pending: number;
  };
}

/** Mirrors the `link_scan_updated` broadcast sent by doc-upload's extract-links handler. */
export interface LinkScanUpdate {
  agent_id: string;
  user_id: string;
  status: "in_progress" | "completed";
  total: number;
  scanned: number;
  found: number;
}

export const knowledgeLinksQueryKey = (agentId: string | undefined) => ["knowledge-links", agentId];
export const linkScanQueryKey = (agentId: string | undefined) => ["knowledge-link-scan", agentId];

/** Links the knowledge-base link scan found for a genie, and starting that scan. */
export class KnowledgeLinksService {
  static list(agentId: string): Promise<KnowledgeLinksResult> {
    return ApiService.invoke<KnowledgeLinksResult>({ resource: "knowledge-base", action: "links", data: { agentId } });
  }

  static scan(agentId: string, force = false): Promise<{ queued: number; total: number }> {
    return ApiService.invoke<{ queued: number; total: number }>({
      resource: "knowledge-base",
      action: "scan-links",
      data: { agentId, force },
    });
  }
}
